import {Link, Badge, Icon} from '@chakra-ui/react'

import { ArrowTopRightOnSquareIcon } from '@heroicons/react/20/solid'

const LinkBadge = ({isMobile}) => {
	return (
		<Link href="/landing" marginLeft="auto" _hover={{opacity: 0.8}}>
			<Badge padding="12px" fontSize={!isMobile ? "xl" : "sm"} colorScheme="purple" display="flex" alignItems="center">
				Pretty Funnels <Icon as={ArrowTopRightOnSquareIcon} marginLeft="6px"/>
			</Badge>
		</Link>
	)
}

export default LinkBadge